import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconLoader = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.7556 19.2079C15.2168 18.7188 15.9608 20.9409 14.4993 21.4299C13.1682 21.8772 11.7531 22.0635 10.3515 21.981C4.2896 21.6229 -0.338615 16.4138 0.0194524 10.3519C0.37752 4.28991 5.58656 -0.338618 11.6485 0.0194514C17.7104 0.377521 22.3386 5.58659 21.9805 11.6485C21.9519 12.1385 21.8874 12.6531 21.7925 13.1344C21.4966 14.6501 19.1917 14.2006 19.4875 12.6846C19.5661 12.2876 19.6154 11.9149 19.6392 11.5109C19.9207 6.74566 16.2764 2.64233 11.5109 2.36109C6.74562 2.07957 2.64232 5.72391 2.36108 10.4895C2.07956 15.2548 5.72359 19.3581 10.4891 19.6393C11.6009 19.705 12.6995 19.5625 13.7556 19.2079Z",
		fill: "#6672FF"
	})
});
export default SvgIconLoader;
